module.exports = __webpack_public_path__ + "6727ee94f5ee926b8b8eac61624d626e.woff";